import React from 'react'
import styled from 'styled-components'
import theme from './themes';

const NavigationContainer = styled.div`
display:flex;
align-items:space-between;

@media screen and (max-width:580px){
    display:flex;

}
`;

const NavigationButton = styled.button`
margin-left:1rem;
border-radius:35px;
background-color:none;
font-weight:bold;
border:none;
padding:${({ small }) => small ?  ".5rem .2rem" : "1rem .8rem"};


&:hover{
    transition:all 0.5s ease-in-out;
    border:1px solid #000080;

}
a{
    text-decoration:none;
    color:${theme.primary};
    padding:16px 32px;


    &:hover{

    }
}
`


function Navigation(props){
return(
<NavigationContainer>
    <NavigationButton {...props}>{props.children}</NavigationButton>
</NavigationContainer>
)
}

export default Navigation